
  <template>
    <ToastService />
    <FileUpload name="carico[]"
                @upload="onTemplatedUpload($event)"
                :multiple="true"
                accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                :maxFileSize="20000000"
                @select="onSelectedFiles"
    >
      <template #header="{ chooseCallback, uploadCallback, clearCallback, files }">
        <div class="flex flex-wrap justify-between items-center flex-1 gap-4">
          <div class="flex gap-2">
            <Button @click="chooseCallback()" icon="pi pi-images" rounded outlined severity="secondary"></Button>
            <Button @click="uploadEvent(uploadCallback)" icon="pi pi-cloud-upload" rounded outlined severity="secondary" :disabled="!files || files.length === 0"></Button>
            <Button @click="clearCallback()" icon="pi pi-times" rounded outlined severity="danger" :disabled="!files || files.length === 0"></Button>
          </div>
          <ProgressBar :value="totalSizePercent" :showValue="false" class="md:w-20rem h-1 w-full md:ml-auto">
            <span class="whitespace-nowrap">{{ totalSize }}B / 20Mb</span>
          </ProgressBar>
        </div>
      </template>
      <template #content="{ files, uploadedFiles, removeUploadedFileCallback, removeFileCallback }">
        <div class="flex flex-col gap-8 pt-4">
          <div v-if="files.length > 0">

            <div class="flex flex-wrap gap-4">
              <div v-for="(file, index) of files" :key="file.name + file.type + file.size" class="p-8 rounded-border flex flex-col border border-surface items-center gap-4">
                <div>
                  <img role="presentation" :alt="file.name" :src="file.objectURL" width="100" height="50" />
                </div>
                <span class="font-semibold text-ellipsis max-w-60 whitespace-nowrap overflow-hidden">{{ file.name }}</span>
                <div>{{ formatSize(file.size) }}</div>
                <Button icon="pi pi-times" @click="onRemoveTemplatingFile(file, removeFileCallback, index)" outlined rounded severity="danger" />
              </div>
            </div>
          </div>

          <div v-if="uploadedFiles.length > 0">

            <div class="flex flex-wrap gap-4">
              <div v-for="(file, index) of uploadedFiles" :key="file.name + file.type + file.size" class="p-8 rounded-border flex flex-col border border-surface items-center gap-4">
                <div>
                  <img role="presentation" :alt="file.name" :src="file.objectURL" width="100" height="50" />
                </div>
                <span class="font-semibold text-ellipsis max-w-60 whitespace-nowrap overflow-hidden">{{ file.name }}</span>
                <div>{{ formatSize(file.size) }}</div>
                <Button icon="pi pi-times" @click="removeUploadedFileCallback(index)" outlined rounded severity="danger" />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #empty>
        <div class="flex items-center justify-center flex-col">
          <i class="pi pi-cloud-upload !border-2 !rounded-full !p-8 !text-4xl !text-muted-color" />
          <p class="mt-6 mb-0">Drag and drop files to here to upload.</p>
        </div>
      </template>
    </FileUpload>
  </template>

<script>
import axios from 'axios';
import ToastService from 'primevue/toastservice';
import FileUpload from 'primevue/fileupload';
import Button from 'primevue/button';
import Badge from 'primevue/badge';
import * as XLSX from 'xlsx';


export default {
  name: "FileMultiploUpload",
  props: ['azioni', 'route_params'],
  components: {
    ToastService,
    FileUpload,
    Button,
    Badge,
  },
  data() {
    return {
      totalSize: 0,
      totalSizePercent: 0,
      files: [],
      columns: [],
    };
  },
  computed: {
    uploadUrl() {
      return route(this.azioni, this.route_params);
    }
  },
  methods: {
    onRemoveTemplatingFile(file, removeFileCallback, index) {
      removeFileCallback(index);
      this.totalSize -= file.size;
      this.totalSizePercent = this.totalSize / 10;
    },
    onClearTemplatingUpload(clear) {
      clear();
      this.totalSize = 0;
      this.totalSizePercent = 0;
    },
    onSelectedFiles(event) {
      this.files = event.files;
      this.totalSize = 0;
      this.files.forEach((file) => {
        this.totalSize += parseInt(this.formatSize(file.size));
      });
    },
      uploadEvent(callback) {
      var vm = this;

      //vm.files['_token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
      let formData = new FormData();
      formData.append('_token', document.querySelector('meta[name="csrf-token"]').getAttribute('content'));
      for (let i = 0; i < vm.files.length; i++) {
        formData.append('carico[]', vm.files[i]);
      }
      //vm.totalSizePercent = vm.totalSize / 10;
      //console.log(vm.files)
      axios.post(this.uploadUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(response => {
          console.log('Upload successful', response);
          window.location.href = route( vm.route, { id: vm.route_params });
        })
        .catch(error => {
          console.error('Upload failed', error);
        });

    },
    onTemplatedUpload() {
      this.$toast.add({ severity: "info", summary: "Success", detail: "File Uploaded", life: 3000 });
    },
    formatSize(bytes) {
      const k = 1024;
      const dm = 3;
      const sizes = ["B", "KB", "MB", "GB", "TB"];
      if (bytes === 0) return `0 ${sizes[0]}`;
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    }
  }
}
</script>

<style scoped>

</style>